import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';

import { getBrand } from 'data_system/affiliate_portal/selectors';

const ExperienceDetailsPage = styled.div``;

export const ExperienceDetails = () => {
  const pageRef = useRef();
  const { bookingRequestId } = useParams();
  const { slug } = useSelector(getBrand);

  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
    (function() {
      window.anyroad = new window.AnyRoad({
          container: '#iframe_wrapper',
          tours: { guide: '${slug}' },
          referrer: { name: '${slug}' },
          bookingRequestId: '${bookingRequestId}'
        });
    })();`;

    pageRef.current.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ExperienceDetailsPage ref={pageRef}>
      <div id="iframe_wrapper" />
    </ExperienceDetailsPage>
  );
};
